import { defineStore } from 'pinia'
import { ErrorCodes, MetaErrorCodes, type BaseError, type Meta } from '@cplug/frontend-core/models'
import { BaseCRUDStore } from '@cplug/frontend-core/stores'
import { CPERPSettingsStandardObservationGateway } from '../gateways/CPERPSettingsStandardObservationGateway'
import type { StandardObservation } from '../models/StandardObservations'

class ERPStandardObservationStore extends BaseCRUDStore<StandardObservation> {
  protected gateway = CPERPSettingsStandardObservationGateway.instance()

  protected findErrors (model: StandardObservation): BaseError[] {
    const defaultErrors = (meta: Meta): BaseError => ({ code: ErrorCodes.DataValidation, meta })
    const errors: BaseError[] = []

    if ((model.title?.trim().length ?? 0) <= 0) {
      errors.push(defaultErrors({ title: MetaErrorCodes.Empty }))
    }

    return errors
  }
}

const useERPStandardObservationStore = defineStore('standard-observations', () => {
  const store = new ERPStandardObservationStore()
  return { ...store.defaultStore() }
})

export default useERPStandardObservationStore
